import { LoginCardConfigType } from '../../../types/ClientConfigDetailTypes';

import { ClientConfigDetailDTO } from '../../dtos/clientConfigDetailsDTO';

class ClientConfigDetail {
  clientId: string;
  layOutType: string;
  brandingSectionMarkdownContent: string;
  customStyles: string;
  fontFamilyType: string;
  headerImgUrl: string;
  footerImgUrl: string;
  troubleLoggingIframeUrl: string;
  seoLink: Array<Record<string, string>>;
  seoMetaData: Array<Record<string, string>>;
  seoTitle: string;
  phoneNumberCardConfig: LoginCardConfigType | undefined;
  otpCardConfig: LoginCardConfigType | undefined;
  headerImgAltText: string | undefined;

  constructor(clientConfigDetailObject: ClientConfigDetailDTO) {
    const {
      clientId,
      layOutType,
      brandingSectionMarkdownContent,
      customStyles,
      fontFamilyType,
      headerImgUrl,
      footerImgUrl,
      troubleLoggingIframeUrl,
      seoLink,
      seoMetaData,
      seoTitle,
      phoneNumberCardConfig,
      otpCardConfig,
      headerImgAltText
    } = clientConfigDetailObject;
    this.clientId = clientId;
    this.layOutType = layOutType;
    this.brandingSectionMarkdownContent = brandingSectionMarkdownContent;
    this.customStyles = customStyles;
    this.fontFamilyType = fontFamilyType;
    this.headerImgUrl = headerImgUrl;
    this.footerImgUrl = footerImgUrl;
    this.troubleLoggingIframeUrl = troubleLoggingIframeUrl;
    this.seoLink = seoLink;
    this.seoMetaData = seoMetaData;
    this.seoTitle = seoTitle;
    this.headerImgAltText = headerImgAltText;
    if (phoneNumberCardConfig) {
      this.phoneNumberCardConfig = phoneNumberCardConfig;
    }
    if (otpCardConfig) {
      this.otpCardConfig = otpCardConfig;
    }
  }
}

export default ClientConfigDetail;
